<template>
    <div id="webform">
        <div class="mt-5 mb-5" v-if="code !== null">
            <v-alert type="warning"
                     class="container"
                     color="orange"
                     v-if="code === 'SAVING'">
                Le formulaire est en cours d'enregistrement. Merci de réessayer plus tard.
            </v-alert>

            <v-alert type="warning"
                     class="container"
                     color="orange"
                     v-if="code === 'NOT_FOUND'">
                Le formulaire n'existe pas.
            </v-alert>

            <v-alert type="warning"
                     class="container"
                     color="orange"
                     v-if="code === 'ARCHIVED'">
                Le formulaire est cloturé.<br>
                Si vous pensez qu'il s'agit d'une erreur, merci de contacter votre partenaire.
            </v-alert>

            <v-alert type="warning"
                     class="container"
                     color="orange"
                     v-if="code === 'ANSWERED'">
                Vous avez déjà répondu à ce formulaire.
            </v-alert>

            <v-alert type="warning"
                     class="container"
                     color="orange"
                     v-if="code === 'DELETED'">
                Le formulaire n'est plus accessible.<br>
                Merci de contacter l'office du tourisme pour plus d'informations.
            </v-alert>
        </div>

        <div class="container mt-5 mb-5" v-if="loaded && !displayThanks">
            <div class="logo">
                <v-img height="100px" position="left" contain :src="logo.doc_url"></v-img>
            </div>

            <div class="mt-4 text-center">
                <h3>{{ provider.name }}</h3>
                <h1 v-if="formTittle === null || formTittle.value === null">Formulaire de validation de vos
                    informations</h1>
                <h1 v-else>{{ formTittle.value }}</h1>
            </div>

            <v-alert type="info"
                     text
                     v-if="txtIntro !== null"
                     class="mt-5 mb-5 form-container mr-auto ml-auto"
                     border="right"
                     colored-border>
                <div v-html="txtIntro.value"></div>
            </v-alert>

            <div class="d-flex mt-3 mb-10 form-container mr-auto ml-auto">
                <p class="mr-2 mt-auto mb-auto">Avez-vous définitivement cessé votre activité ?</p>

                <v-radio-group v-model="openThisSeason" row class="mt-auto mb-auto">
                    <v-radio label="Non" :value="false"></v-radio>
                    <v-radio label="Oui" :value="true"></v-radio>
                </v-radio-group>
            </div>

      <v-expand-transition>
        <div v-if="!openThisSeason">
          <general :languages="languages" :read-only="false" class="mt-5"></general>

          <localisation :read-only="false" class="mt-5"></localisation>

          <contacts class="mt-5" :contacts="contacts" :read-only="false"></contacts>

          <medias :read-only="false" class="mt-5"></medias>

                    <room-renting class="mt-5"></room-renting>

          <specific :read-only="false" class="mt-5"></specific>

          <opening-hours :read-only="false" class="mt-5"></opening-hours>

          <price-periods :read-only="false" class="mt-5"></price-periods>

                    <capacities class="mt-5"></capacities>

                    <covid></covid>
                </div>
            </v-expand-transition>

            <extra></extra>

            <v-alert color="rgb(209, 236, 241)" class="mt-4 form-container mr-auto ml-auto">
                <div class="d-flex cgu-box">
                    <div class="mt-auto mb-auto">
                        <v-checkbox v-model="acceptCgu"
                                    hide-details>
                        </v-checkbox>
                    </div>
                    <div>
                        <span>Je certifie avoir lu et accepté </span>
                        <a :href="cgu" target="_blank">{{ cguText }}</a>
                        <span> de {{ organism.value }}</span>
                    </div>
                </div>
            </v-alert>

            <p class="mt-4 form-container mr-auto ml-auto">{{ thxMessage }}</p>

            <v-alert type="warning" class="mt-4 mb-5 form-container mr-auto ml-auto" v-if="webFormState === 'SAVING'">
                Le formulaire est en cours d'enregistrement. Cette actions peut prendre plusieurs minutes.<br>
                Vous pourrez revenir plus tard pour le compléter et le valider définitivement.<br>
                Pour cela connectez vous avec le lien reçu précédemment par e-mail.
                <v-progress-linear
                  class="mt-2"
                  indeterminate
                  color="yellow darken-2"
                ></v-progress-linear>
            </v-alert>

            <div
              class="form-container mr-auto ml-auto action-buttons mb-4 w-100 d-flex justify-content-between flex-wrap">
                <div class="text-center w-100 mt-2">
                    <v-btn color="primary" @click="save(true)" :disabled="webFormState === 'SAVING' || openThisSeason">
                        <v-icon small class="mr-2">save</v-icon>
                        Enregistrer et revenir plus tard
                    </v-btn>
                </div>

                <div class="text-center w-100 m-2">
                    <v-btn color="primary" :disabled="!acceptCgu || webFormState === 'SAVING'" @click="validBeforeSave">
                        <v-icon small class="mr-2">check</v-icon>
                        Valider mes informations
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="container web-form-thanks mb-5" v-if="displayThanks">
            <v-alert style="margin-bottom: 50px">
                <div class="d-flex justify-content-start">
                    <div class="logo">
                        <v-img height="100px" position="center" contain :src="logo.doc_url"></v-img>
                    </div>

                    <div>
                        <h4>Merci pour votre réponse !</h4>
                        <div>
                            {{ organism.value }} vous remercie d'avoir mis à jour vos informations.
                        </div>

                        <div class="mt-2">
                            <router-link :to="'/espace-pro/' + contact.token + '/solicitations' + '?no_redirection=true'">
                                Revenir à mon espace pro
                                <v-icon large>arrow_right_alt</v-icon>
                            </router-link>
                        </div>
                    </div>
                </div>
            </v-alert>
        </div>

        <div class="text-center mb-5" v-if="loaded && !displayThanks">
            Service <a target="_blank" href="http://dahub.io">Dahub</a>
        </div>

        <div class="bubble-info" v-if="loaded && !displayThanks" @click="infoDialog = true">
            <v-icon color="primary">info</v-icon>
        </div>

        <v-dialog v-model="infoDialog" max-width="600px" v-if="!displayThanks">
            <v-card>
                <v-card-title>
                    <h2 class="headline-title">Une question ? Besoin d'informations ?</h2>
                </v-card-title>
                <v-card-text>
                    <v-spacer></v-spacer>
                    <p class="text-center">Contactez-nous</p>
                    <div class="mt-3 text-center">
                        <a :href="'mailto:' + referent.emailable.email">{{ referent.emailable.email }}</a>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="copyrightDialog" max-width="700px">
            <v-card>
                <v-card-title>
                    <h2 style="font-size: 20px !important;" class="headline-title">
                        Attention : certaines photos n'ont pas de copyright
                    </h2>
                </v-card-title>
                <v-card-text>
                    <h3 class="mt-2 headline-title" style="font-size: 14px">Qu'est-ce que le copyright ?</h3>

                    <div>
                        Le copyright est un libellé qui désigne l'identité du titulaire des droits de la photo
                        (personne physique ou personne morale). Il atteste que l'auteur est d'accord que vous diffusiez
                        ses photos.
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Connaissez-vous l'auteur des photos ?</h3>

                    <div>
                        Si oui, et que celui-ci vous a octroyé les droits d'utilisation de la photo, alors vous pouvez
                        indiquer son nom en tant que copyright. Sinon il est préférable de ne pas diffuser la photo
                        (et de la retirer de ce formulaire).
                    </div>

                    <h3 class="mt-4 headline-title" style="font-size: 14px">Pourquoi est-ce important de saisir un
                        copyright
                        ?</h3>

                    <div>
                        Sans copyright, l'auteur de la photo peut se retourner contre nous et réclamer des réparations
                        pour
                        diffusion de la photo sans autorisation.
                        Pour éviter cette situation, nous ne diffusons pas de photos sans copyright.
                    </div>

                    <v-spacer></v-spacer>

                    <div class="d-flex justify-content-between mt-5">
                        <v-btn class="text-none" color="error" outlined @click="confirmCopyrights">
                            Valider sans modifier mes copyrights
                        </v-btn>
                        <v-btn class="text-none" color="success" outlined @click="scrollToMedias()">
                            Ajouter mes copyrights
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="confirmOpeningPeriodDialog" max-width="700px" v-if="loaded">
            <v-card>
                <v-card-title>
                    <h2 style="font-size: 20px !important;" class="headline-title"
                        v-if="provider.opening_periods.length !== 0">
                        Attention : vos périodes et horaires d'ouverture sont inchangés
                    </h2>
                    <h2 style="font-size: 20px !important;" class="headline-title" v-else>
                        Attention : vous n'avez pas saisi de périodes et horaires d'ouverture
                    </h2>
                </v-card-title>
                <v-card-text>
                    <div v-if="provider.opening_periods.length !== 0">
                        Vos périodes et horaires d'ouverture n'ont pas été modifiés. Confirmez-vous qu'ils sont valides
                        ?
                    </div>
                    <div v-else>
                        Confirmez-vous que vous n'êtes pas ouvert selon certaines périodes et horaires ?
                    </div>

                    <v-spacer></v-spacer>

                    <div class="d-flex justify-content-between mt-5">
                        <v-btn class="text-none"
                               color="warning"
                               outlined
                               @click="scrollToOpeningPeriods"
                               v-if="provider.opening_periods.length !== 0">
                            Modifier mes périodes et horaires d'ouverture
                        </v-btn>
                        <v-btn class="text-none"
                               color="warning"
                               outlined
                               @click="scrollToOpeningPeriods"
                               v-else>
                            Ajouter une période et horaires d'ouverture
                        </v-btn>

                        <v-btn class="text-none" color="success" outlined @click="confirmOpeningPeriods">
                            Je confirme
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="confirmPricePeriodDialog" max-width="700px" v-if="loaded">
            <v-card>
                <v-card-title>
                    <h2 style="font-size: 20px !important;" class="headline-title"
                        v-if="provider.price_periods.length !== 0">
                        Attention : vos tarifs sont inchangés
                    </h2>
                    <h2 style="font-size: 20px !important;" class="headline-title" v-else>
                        Attention : vous n'avez pas saisi de tarifs
                    </h2>
                </v-card-title>
                <v-card-text>
                    <div v-if="provider.price_periods.length !== 0">
                        Vos tarifs n'ont pas été modifiés. Confirmez-vous qu'ils sont valides ?
                    </div>
                    <div v-else>
                        Confirmez-vous que vous n'avez pas de tarifs à communiquer ?
                    </div>

                    <v-spacer></v-spacer>

                    <div class="d-flex justify-content-between mt-5">
                        <v-btn class="text-none"
                               color="warning"
                               outlined
                               @click="scrollToPricePeriods"
                               v-if="provider.price_periods.length !== 0">
                            Modifier mes tarifs
                        </v-btn>
                        <v-btn class="text-none"
                               color="warning"
                               outlined
                               @click="scrollToPricePeriods"
                               v-else>
                            Ajouter des tarifs
                        </v-btn>
                        <v-btn class="text-none" color="success" outlined @click="confirmPricePeriods">Je confirme
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import General from "./tabulations/General"
import Localisation from "./tabulations/Localisation"
import Contacts from "./tabulations/Contacts"
import Extra from "./tabulations/Extra"
import { mapGetters, mapMutations, mapState } from "vuex"
import Covid from "./tabulations/Covid"
import Medias from "./tabulations/Medias"
import Capacities from "./tabulations/Capacities"
import Specific from "./tabulations/Specific"
import RoomRenting from "./tabulations/RoomRenting"
import OpeningHours from "./tabulations/OpeningHours"
import PricePeriods from "./tabulations/PricePeriods"
import * as EmailValidator from "email-validator"
import PhoneNumber from "awesome-phonenumber"

export default {
    name: "Webform",
    components: {
        PricePeriods,
        OpeningHours,
        RoomRenting, Specific, Capacities, Medias, Covid, Extra, Contacts, Localisation, General,
    },
    data() {
        return {
            token: null,
            code: null,
            languages: [],
            loaded: false,
            communes: [],
            contacts: [],
            cguText: "Les Conditions d'utilisation ainsi que le Règlement sur le respect de la vie privée",
            acceptCgu: false,
            infoDialog: false,
            thxMessage: "Merci pour votre participation.",
            referent: { emailable: {} },
            openThisSeason: false,
            campaign: {},
            logo: {},
            cgu: null,
            organism: {},
            txtIntro: {},
            formTitle: null,
            typeFormUrl: null,
            redirectUrl: null,
            displayThanks: false,
            comToParses: [],
            dayToParses: [],
            suggestedLocalisation: null,
            copyrightDialog: false,
            baseOpeningPeriods: null,
            basePricePeriods: null,
            areOpeningPeriodsDifferent: false,
            arePricePeriodsDifferent: false,
            confirmOpeningPeriodDialog: false,
            confirmPricePeriodDialog: false,
            hasConfirmedOpeningPeriods: false,
            hasConfirmedPricePeriods: false,
            hasConfirmedCopyrights: false,
            draftInterval: null,
            webFormState: null,
            h24Suggested: false,
        }
    },
    methods: {
        ...mapMutations("web_form", [
            "resetState", "setProvider", "setFields", "setFamilyElements",
            "setContact", "setSubmitted", "setCapacities", "setRoomRenting", "setCurrencies", "setCategoryFamilies",
            "setSuggestedMedias", "pushSuggestedMedias", "pushSuggestedCommunications", "setSourcesLoaded",
            "setSuggestedAddress", "setSuggestedCommune", "setSuggestedOpeningDays", "setExtra", "setSuggestedH24",
            "setAllSuggestedMediasLoaded", 'setAccountTisType',
        ]),
        getProvider() {
            this.$global.loading = true

            return this.$http.get("webform/" + this.token).then(res => {
                if (res.body.success) {
                    let families = res.body.data.categoryFamilies
                    this.campaign = res.body.data.campaign

                    let provider = res.body.data.provider
                    let answer = res.body.data.answer
                    this.cgu = res.body.data.cgu

                    if (provider.price_periods !== undefined && provider.price_periods !== null) {
                        provider.price_periods.forEach(pricePeriod => {
                            pricePeriod.prices.map(price => {
                                price.min /= 100
                                price.max /= 100

                                return price
                            })
                        })
                    }

                    this.setProvider(provider)
                    this.setFamilyElements(res.body.data.referential)
                    this.setContact(res.body.data.contact)
                    this.setRoomRenting(res.body.data.provider.room_renting)
                    this.setCategoryFamilies(families)
                    this.setAccountTisType(res.body.data.accountTisType)

                    if (answer !== null) {
                        let contact = {
                            first_name: answer.first_name,
                            last_name: answer.last_name,
                            email: answer.email,
                            id: res.body.data.contact.id,
                            token: res.body.data.contact.token,
                        }

                        this.setExtra(answer.extra)
                        this.setContact(contact)
                    }

                    let capacities = this.getFamilyByCode("Capacites")

                    this.setCapacities(capacities)

                    let config = res.body.data.configurations

                    this.logo = config.logo
                    this.organism = config.organism
                    this.txtIntro = config.txtIntro
                    this.formTitle = config.formTitle
                    this.referent = res.body.data.referent

                    this.typeFormUrl = res.body.data.typeFormUrl
                    this.redirectUrl = res.body.data.redirectUrl

                    if (this.user === null || this.user === undefined) {
                        this.$http.get("webform/opened/" + this.token)
                    }

                    this.$global.loading = false
                    this.loaded = true
                }

                if (res.body.code !== null) {
                    this.code = res.body.code

                    this.$global.loading = false
                }
            })
        },
        getFields() {
            return this.$http.get("webform/fields/" + this.token).then(res => {
                if (res.body.success) {
                    this.setFields(res.body.data.fields)
                }
            })
        },
        getInitData() {
            return this.$http.get("webform/init-data/" + this.token).then(res => {
                if (res.body.success) {
                    let initProvider = res.body.data.initProvider

                    if (initProvider === null) {
                        initProvider = this.provider
                    }

                    initProvider.opening_periods.forEach(period => {
                        if (period.opening_days === undefined) {
                            period.opening_days = [
                                { closed: true, day_of_week: 0 },
                                { closed: true, day_of_week: 1 },
                                { closed: true, day_of_week: 2 },
                                { closed: true, day_of_week: 3 },
                                { closed: true, day_of_week: 4 },
                                { closed: true, day_of_week: 5 },
                                { closed: true, day_of_week: 6 },
                            ]
                        }

                        period.opening_days.forEach(day => {
                            if (day.opening_hours === undefined) {
                                this.$set(day, "opening_hours", [])
                            }
                        })
                    })

                    initProvider.price_periods.forEach(period => {
                        period.prices.forEach(price => {
                            if (price.min !== null) {
                                price.min /= 100
                            }

                            if (price.max !== null) {
                                price.max /= 100
                            }
                        })
                    })

                    setTimeout(() => {
                        this.baseOpeningPeriods = JSON.parse(JSON.stringify(initProvider.opening_periods))
                        this.basePricePeriods = JSON.parse(JSON.stringify(initProvider.price_periods))

                        this.basePricePeriods.forEach(period => {
                            delete period.selectedElements
                            delete period.availableElements
                            delete period.currency

                            period.valid_from = this.$moment(period.valid_from).format("YYYY-MM-DD HH:mm:ss")
                            period.valid_through = this.$moment(period.valid_through).format("YYYY-MM-DD HH:mm:ss")

                            if (period.external_id !== null && period.external_id !== undefined) {
                                period.external_id = period.external_id.toString()
                            }
                        })

                        this.baseOpeningPeriods.forEach(period => {
                            if (period.external_id !== null && period.external_id !== undefined) {
                                period.external_id = period.external_id.toString()
                            }
                        })

                        this.basePricePeriods = JSON.stringify(this.basePricePeriods)
                        this.baseOpeningPeriods = JSON.stringify(this.baseOpeningPeriods)
                    }, 2000)
                }
            })
        },
        getLanguages() {
            this.$http.get("resource/languages").then(res => {
                this.languages = res.body.data.languages
            })
        },
        getCommunicationTypes() {
            this.$http.get("resource/communication-types").then(res => {
                this.contacts = res.body.data.contacts
            })
        },
        getCurrencies() {
            this.$http.get("resource/currencies").then(res => {
                this.setCurrencies(res.body.data.currencies)
            })
        },
        hasEmptyCopyrights() {
            return this.provider.medias.filter(media => media.copyright === null || media.copyright === "").length !== 0
        },
        validBeforeSave() {
            this.setSubmitted(true)

            let validation = this.contact.email !== null && this.contact.email !== "" &&
              this.contact.first_name !== null && this.contact.first_name !== "" &&
              this.contact.last_name !== null && this.contact.last_name !== "" &&
              EmailValidator.validate(this.contact.email)

            let pricePeriodsCopy = JSON.parse(JSON.stringify(this.provider.price_periods))
            let openingPeriodsCopy = JSON.parse(JSON.stringify(this.provider.opening_periods))

            pricePeriodsCopy.forEach(period => {
                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }

                delete period.id
                delete period.created_at
                delete period.updated_at
                delete period.price_period_version_id
                delete period.currency_id
                delete period.currency

                delete period.selectedElements
                delete period.availableElements
            })

            openingPeriodsCopy.forEach(period => {
                period.h24 = false

                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }

                delete period.id
                delete period.created_at
                delete period.updated_at
                delete period.period_version_id

                period.opening_days.forEach(day => {
                    delete day.id
                    delete day.created_at
                    delete day.updated_at
                    delete day.opening_period_id

                    if (day.opening_hours !== undefined) {
                        day.opening_hours.forEach(hour => {
                            delete hour.id
                            delete hour.created_at
                            delete hour.updated_at
                        })
                    }
                })
            })

            this.areOpeningPeriodsDifferent = this.baseOpeningPeriods !== JSON.stringify(openingPeriodsCopy)
            this.arePricePeriodsDifferent = this.basePricePeriods !== JSON.stringify(pricePeriodsCopy)

            if (validation) {
                if (this.hasField("IMAGE") && this.hasEmptyCopyrights() && !this.hasConfirmedCopyrights) {
                    this.copyrightDialog = true
                } else if (!this.areOpeningPeriodsDifferent && !this.hasConfirmedOpeningPeriods && this.hasField("OPENING_HOURS")) {
                    this.confirmOpeningPeriodDialog = true
                } else if (!this.arePricePeriodsDifferent && !this.hasConfirmedPricePeriods && this.hasFamilyElement("OfferType")) {
                    this.confirmPricePeriodDialog = true
                } else {
                    this.save(false)
                }
            }
        },
        save(draft) {
            this.copyrightDialog = false

            this.fixData()

            let payload = {
                provider: this.provider,
                contact: this.contact,
                token: this.token,
                extra: this.extra,
                openThisSeason: this.openThisSeason ? 0 : 1,
                draft: draft,
            }

            this.$global.loading = true

            this.$http.post("webform/answer", payload).then(res => {
                this.setSubmitted(false)
                this.$global.loading = false

                if (!draft) {
                    this.displayThanks = true

                    window.scrollTo(0, 0)

                    this.completeTypeFormUrl()
                } else {
                    this.webFormState = "SAVING"

                    this.draftInterval = setInterval(() => {
                        this.$http.get("webform/state/" + this.token).then(res => {
                            this.webFormState = res.body.data.state.code
                        })
                    }, 5000)
                }
            })
        },
        fixData() {
            if (this.provider.localisation.commune !== undefined && this.provider.localisation.commune !== null) {
                this.provider.localisation.commune_id = this.provider.localisation.commune.id
            }

            this.provider.capacities = this.capacities.filter(capacity => {
                return capacity.value !== undefined && capacity.value !== ""
            })

            this.provider.room_renting = this.roomRenting

            this.provider.price_periods.forEach(period => {
                period.prices.map(price => {
                    if (price.mode === "UNIQUE") {
                        price.max = price.min
                    } else if (price.mode === "FROM") {
                        price.max = null
                    }
                })
            })

            if (this.provider.room_renting !== undefined) {
                this.provider.room_renting.rooms.forEach(room => {
                    if (room.area !== null) {
                        room.area = room.area.toString().replace(",", ".")
                    }
                })
            }

            if (this.provider.opening_periods !== undefined) {
                this.provider.opening_periods.forEach(period => {
                    period.opening_days.forEach(day => {
                        if (day.closed === null) {
                            day.closed = day.opening_hours === undefined || day.opening_hours.length === 0
                        }
                    })
                })
            }
        },
        fetchExternalMedias(source) {
            this.$global.loading = true

            let payload = {
                source: source,
                token: this.token,
                mediaLimit: 3,
            }

            return this.$http.post("online-presence/medias", payload).then(res => {
                let medias = res.body.data.medias
                let communications = res.body.data.communications
                let localisation = res.body.data.localisation
                let openingDays = res.body.data.openingDays ?? []
                let h24 = res.body.data.h24

                if (h24) {
                    this.setSuggestedH24(h24)
                }

                if (medias.length < 3 && source === "GOOGLE") {
                    this.setAllSuggestedMediasLoaded(true)
                }

                medias = medias.map(media => {
                    if (media.thumbnail_url === null) {
                        media.thumbnail_url = media.origin_url
                    }

                    return media
                })

                this.comToParses = [...this.comToParses, ...communications]
                this.dayToParses = [...this.dayToParses, ...openingDays]
                this.h24Suggested = h24

                this.pushSuggestedMedias(medias)

                if (localisation !== null) {
                    this.suggestedLocalisation = localisation
                }
            })
        },
        sortSuggestedMedias() {
            let sorted = this.suggestedMedias.sort((media1, media2) => {
                return media2.quality - media1.quality
            })

            this.setSuggestedMedias(sorted.slice(0, 10))
        },
        completeTypeFormUrl() {
            this.typeFormUrl += "&mail=" + this.contact.email

            let phone = this.provider.communications.find(com => com.type.name === "PHONE")

            if (phone !== null && phone !== undefined) {
                this.typeFormUrl += "&phone=" + phone.value
            }

            this.typeFormUrl += "&prenom=" + this.contact.first_name
            this.typeFormUrl += "&redirection=" + this.redirectUrl
            this.typeFormUrl += "&offer_name=" + this.provider.name
        },
        parseSuggestedCommunications() {
            if (this.comToParses && this.suggestedCommunications) {
                this.comToParses.forEach(com => {
                    let hasSuggestion = this.suggestedCommunications.find(suggestedCom => suggestedCom.type.name === com.type.name)

                    if (hasSuggestion === undefined && this.provider !== null) {
                        let hasSameValue = false

                        this.provider.communications.forEach(providerCom => {
                            if (providerCom.type.name === com.type.name && !hasSameValue) {
                                if (providerCom.type.name === "PHONE" || providerCom.type.name === "FAX") {
                                    let phone1 = com.value !== null ?? new PhoneNumber(com.value, "FR").getNumber()
                                    let phone2 = providerCom.value !== null ?? new PhoneNumber(providerCom.value, "FR").getNumber()

                                    hasSameValue = phone1 === phone2
                                } else if (["WEBSITE", "TRIPADVISOR", "YELP", "FACEBOOK", "GOOGLE", "YOUTUBE", "INSTAGRAM", 'WEBSITE_EN']
                                  .includes(providerCom.type.name)) {
                                    let url1 = com.value ?? ""

                                    url1 = url1.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                    let url2 = providerCom.value ?? ""

                                    url2 = url2.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                    if (url1.charAt(url1.length - 1) === "/") {
                                        url1 = url1.substr(0, url1.length - 1)
                                    }

                                    if (url2.charAt(url2.length - 1) === "/") {
                                        url2 = url2.substr(0, url2.length - 1)
                                    }

                                    if (com.type.name === "GOOGLE") {
                                        let index1 = url1.indexOf("&")
                                        if (index1 >= 0) {
                                            url1 = url1.slice(0, index1)
                                        }

                                        let index2 = url2.indexOf("&")
                                        if (index2 >= 0) {
                                            url2 = url2.slice(0, index2)
                                        }
                                    } else if (["FACEBOOK", "INSTAGRAM"].includes(com.type.name)) {
                                        let index1 = url1.indexOf("?")
                                        if (index1 >= 0) {
                                            url1 = url1.slice(0, index1 - 1)
                                        }

                                        let index2 = url2.indexOf("?")
                                        if (index2 >= 0) {
                                            url2 = url2.slice(0, index2 - 1)
                                        }
                                    }

                                    hasSameValue = url1 === url2
                                } else if (providerCom.value === com.value) {
                                    hasSameValue = true
                                }
                            }
                        })

                        if (!hasSameValue) {
                            this.pushSuggestedCommunications([com])
                        }
                    }
                })
            }
        },
        parseSuggestedLocalisation() {
            if (this.provider !== undefined) {
                let lowerAddr = this.provider.localisation.address !== null ? this.provider.localisation.address.toLocaleLowerCase() : null

                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.address !== null &&
                  this.suggestedLocalisation.address.toLocaleLowerCase() !== lowerAddr) {

                    let lowerSuggestAddr = this.suggestedLocalisation.address.toLocaleLowerCase()
                    lowerSuggestAddr = lowerSuggestAddr.replace(',', '')
                    lowerAddr = lowerAddr.replace(",", "")

                    if (lowerSuggestAddr !== lowerAddr) {
                        this.setSuggestedAddress(this.suggestedLocalisation.address)
                    }
                }

                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.commune !== null &&
                  this.suggestedLocalisation.commune.id !== this.provider.localisation.commune.id) {

                    this.setSuggestedCommune(this.suggestedLocalisation.commune)
                }
            }
        },
        parseSuggestedOpeningDays() {
            if (this.provider.opening_periods.length === 0) {
                this.setSuggestedOpeningDays(this.dayToParses)
            } else {
                let period = this.provider.opening_periods[0]

                this.dayToParses.forEach(dayToParse => {
                    let day = period.opening_days.find(openingDay => openingDay.day_of_week === dayToParse.day_of_week)

                    if (day !== null && day !== undefined) {
                        let isDifferent = day.opening_hours.length !== dayToParse.opening_hours.length ||
                          (day.opening_hours[0] !== undefined &&
                            dayToParse.opening_hours[0] !== undefined &&
                            (day.opening_hours[0].open !== dayToParse.opening_hours[0].open ||
                              day.opening_hours[0].close !== dayToParse.opening_hours[0].close)) ||
                          (day.opening_hours[1] !== undefined &&
                            dayToParse.opening_hours[1] !== undefined &&
                            (day.opening_hours[1].open !== dayToParse.opening_hours[1].open ||
                              day.opening_hours[1].close !== dayToParse.opening_hours[1].close))

                        if (isDifferent) {
                            this.setSuggestedOpeningDays([dayToParse])
                        }
                    }
                })
            }
        },
        scrollToMedias() {
            this.copyrightDialog = false

            document.getElementById("multimedia-section").scrollIntoView()
        },
        scrollToOpeningPeriods() {
            this.confirmOpeningPeriodDialog = false

            document.getElementById("opening-periods-section").scrollIntoView()
        },
        scrollToPricePeriods() {
            this.confirmPricePeriodDialog = false

            document.getElementById("price-periods-section").scrollIntoView()
        },
        confirmOpeningPeriods() {
            this.confirmOpeningPeriodDialog = false
            this.hasConfirmedOpeningPeriods = true
            this.validBeforeSave()
        },
        confirmPricePeriods() {
            this.confirmPricePeriodDialog = false
            this.hasConfirmedPricePeriods = true
            this.validBeforeSave()
        },
        confirmCopyrights() {
            this.copyrightDialog = false
            this.hasConfirmedCopyrights = true
            this.validBeforeSave()
        },
    },
    computed: {
        ...mapState("web_form", ["provider", "contact", "extra", "submitted", "capacities",
            "roomRenting", "suggestedMedias", "suggestedCommunications"]),
        ...mapState("account", ["user"]),
        ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode"]),
    },
    watch: {
        webFormState() {
            if (this.draftInterval !== null && this.webFormState === "DRAFT") {
                clearInterval(this.draftInterval)
            }
        },
    },
    async created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        this.resetState()

        this.token = this.$route.params.token

        const promise1 = this.getProvider()
        const promise2 = this.getFields()
        const promise3 = this.fetchExternalMedias("GOOGLE")
        const promise4 = this.fetchExternalMedias("GOOGLE_CUSTOM")

        Promise.all([promise1, promise2, promise3, promise4]).then(() => {
            // this.sortSuggestedMedias()
            this.setSourcesLoaded(true)
            this.parseSuggestedCommunications()
            this.parseSuggestedLocalisation()
            this.parseSuggestedOpeningDays()
            this.getInitData()
        })

        this.getLanguages()
        this.getCommunicationTypes()
        this.getCurrencies()
    },
}
</script>
